document.addEventListener("DOMContentLoaded", function () {
	const brandsContainer = document.querySelector(".brands__items");
	const leftArrow = document.querySelector(".brands__arrow--left");
	const rightArrow = document.querySelector(".brands__arrow--right");

	if (brandsContainer && leftArrow && rightArrow) {
		leftArrow.addEventListener("click", () => {
			brandsContainer.scrollBy({ left: -300, behavior: "smooth" });
		});

		rightArrow.addEventListener("click", () => {
			brandsContainer.scrollBy({ left: 300, behavior: "smooth" });
		});
	}
});